import { Button, Icon } from '@iq/react-components';

import { getWizardCards, isWizardStepComplete } from '../../wizardConfig.js';
import config from '../../../../../config';

const handleWizardSelectionKeyDown = (event, wizardType, onWizardType) => {
  if (event.key === 'Enter' || event.key === ' ') {
    event.preventDefault();
    onWizardType(wizardType);
  }
};

const StepDescription = ({ text, checked = false }) => (
  <li
    data-testid={checked ? 'checked-step' : undefined}
    className={`checked-step${checked ? '--checked' : ''}`}
  >
    <div>
      <Icon
        icon="he-systemfeedbacksuccess"
        size="l"
      />
    </div>
    <div>{text}</div>
  </li>
);

const WizardTypeStep = (properties) => {
  const { site, onWizardType } = properties;
  const isOnPrem = Boolean(config?.onPremise);
  const wizardCards = getWizardCards();

  return (
    <>
      <div className="wizard-step-top">
        <div className="wizard-step-top__header--wizard-select">
          <p>{isOnPrem ? '' : 'Choose a configuration plan to start'}</p>
        </div>
      </div>
      <div className="wizard-type-step">
        {wizardCards.map((wizardCard) => (
          <div
            key={wizardCard.name}
            className={`wizard-select wizard-select-${wizardCard.theme}`}
            onClick={() => onWizardType(wizardCard.name)}
            onKeyDown={(event) =>
              handleWizardSelectionKeyDown(event, wizardCard.name, onWizardType)
            }
            role="button"
            tabIndex={0}
          >
            <div className="wizard-select__vertical-container">
              <div className="wizard-select__heading">
                <div className="wizard-select__header">{wizardCard.label}</div>
                <div className="wizard-select__subheader">
                  <div>{wizardCard.description}</div>
                </div>
              </div>
              <ul className="wizard-select__description">
                {wizardCard.cardSteps.map((wizardStep) => (
                  <StepDescription
                    key={wizardStep.name}
                    checked={isWizardStepComplete(site, wizardCard.name, wizardStep.name)}
                    text={wizardStep.cardLabel}
                  />
                ))}
              </ul>
              <div className="wizard-select__button-container">
                <Button
                  className={`wizard-select__button wizard-select__button--${wizardCard.theme}`}
                  onClick={(event) => {
                    event.stopPropagation();
                    onWizardType(wizardCard.name);
                  }}
                >
                  Start
                </Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default WizardTypeStep;
